module.exports = __webpack_public_path__ + "img/symbol_0.fe0d4cb7.png";